<script context="module">
  export const showAllFields = true;

  const productTileDefaultOptions = {
    showProductTags: showAllFields,
    showFavIcon: showAllFields,
    showPrice: showAllFields,
    showRatingReview: showAllFields,
    showOfferAndGift: showAllFields,
    showBottomTags: showAllFields,
    showActionBtn: showAllFields,
    isBundleProduct: false,
    isRRComponent: false,
    mobileTileWidth: 300,
    desktopTileWidth: 318,
    favIconMobileWidth: 24,
    favIconDesktopWidth: 32,
  };
</script>

<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';
  import { fade } from 'svelte/transition';

  import { getAppConfig } from '../../../../common/config/app-config';
  import { checkForMegaSaleProduct, getProductTags, getStr } from '../../../../common/util';
  import { getBottomTags } from '../../../brand/services/brand-data-services';
  import { cartLoginDetails } from '../../../header/store/header_store';
  import { redirectToPdp } from '../../../product-details/services/pdp-data-services';
  import { productTileStore } from '../../store/product-tile_store';
  import OnlineOnlyLabel from './components/OnlineOnlyLabel.svelte';
  import ProductBottomTags from './components/ProductBottomTags.svelte';
  import ProductTileHead from './components/ProductTileHeader.svelte';
  // import ProductTileImage from './components/ProductTileImage.svelte';
  import ProductTileName from './components/ProductTileName.svelte';
  import ProductTileOffer from './components/ProductTileOffer.svelte';
  import ProductTilePriceNewGroup from './components/ProductTilePriceNewGroup.svelte';
  import { getCartLoginDetails } from '../../../header/services/header-service';
  import ProductTilePriceNewWalletGroup from './components/ProductTilePriceNewWalletGroup.svelte';
  import ProductTileRatingReviews from './components/ProductTileRatingReviews.svelte';

  export let data;
  export let productDataForGTM;
  export let options = {};

  $: productCode = data?.code || data?.productCode;
  $: opt = { ...productTileDefaultOptions, ...options };
  export let productTags = getProductTags(data);
  export let productBottomTags = getBottomTags(data);

  const { categoryCode, categoryName, encodedContextPath, benefitType = 'DISCOUNT' } = getAppConfig();
  const priceComponent = benefitType === 'WALLET' ? ProductTilePriceNewWalletGroup : ProductTilePriceNewGroup;

  let wishlistedProductCodes = [];

  const dispatch = createEventDispatcher();
  const primeCardClass =
    data?.primeEnabled && (data?.basicPrimePrice > 0 || data?.vipPrimePrice > 0) ? 'product-card-has-prime' : '';

  const toggleWishlist = data => {
    // data.detail.event.stopPropagation();
    dispatch('toggleFav', data.detail);
  };

  $: wishlisted = wishlistedProductCodes && wishlistedProductCodes.indexOf(productCode) > -1;
  $: showPriceForComingSoon = !data?.comingSoon || (data?.comingSoon && !data?.hidePriceForComingSoon);

  cartLoginDetails.subscribe(cld => {
    wishlistedProductCodes =
      cld?.customer?.wishlist?.entries?.filter(x => x.product !== null).map(x => x.product?.code) || [];
  });
  let productStore = null;

  onMount(() => {
    getCartLoginDetails();
    productStore = productTileStore(data);
    if (!wishlistedProductCodes.length && getAppConfig()?.wishlistProducts?.length && !$cartLoginDetails) {
      wishlistedProductCodes = [...getAppConfig().wishlistProducts];
    }
  });

  function redirectToProductDetail(url) {
    // Check if a URL is provided
    if (!url) {
      // If not, attempt to use urlEn or fallback to productDataForGTM
      url = data?.urlEn ? `${encodedContextPath}${data?.urlEn}` : `${encodedContextPath}${productDataForGTM?.urlEn}`;
    }

    // Ensure we have a valid URL before proceeding
    if (!url) {
      console.error('No valid URL found for redirection.');
      return; // Early exit if no URL is available
    }
    // Track the item if the tracking method exists
    if ('extragtm' in window['ACC']) {
      window['ACC'].extragtm.click.trackSelectItem(categoryCode, categoryName, productDataForGTM);
    }

    // Mirakl click tracking
    if (data?.miraklad) {
      window.ACC.miraklads.registerClickAsync(data.miraklad.adId);
      url += '?sponsored=true';
    }

    // Redirect to the product detail page
    redirectToPdp(url);
  }
  function highlightJoodCard() {

    const { joodDayTheme } = productStore.productTilePriceData || {};
    let borderWidth = '1px';
    const joodBorderColors = joodDayTheme ? joodDayTheme : '#dbe3e8';
    if (joodDayTheme) {
      borderWidth = '2px';
    }
    return `${borderWidth} solid ${joodBorderColors}`;
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
{#if !!productStore}
  <div
    on:click={() => redirectToProductDetail(data?.pdpUrl)}
    class="position-relative tile-content-wrapper"
    style:--mobile-tile-width="{opt?.mobileTileWidth}px"
    style:--desktop-tile-width="{opt?.desktopTileWidth}px"
    in:fade
  >
    <div
      class="product-tile-container {primeCardClass} {opt?.isBundleProduct
        ? 'product-tile-container-bundleMinHeight'
        : ''}"
      style:--tile-height="calc(100%)"
      style:border={highlightJoodCard()}
    >
      <section class="tags-fav-action-section">
        {#if (opt?.showProductTags && productTags?.length) || opt?.showFavIcon}
          <ProductTileHead
            data={productStore.productTileHeaderData}
            options={{
              isRRComponent: opt?.isRRComponent,
              showFavIcon: opt?.showFavIcon,
              showTags: opt?.showProductTags,
              favIconMobileWidth: opt?.favIconMobileWidth,
              favIconDesktopWidth: opt?.favIconDesktopWidth,
              isWishlisted: wishlisted,
            }}
            {productDataForGTM}
            on:changeWishList={data => {
              toggleWishlist(data);
            }}
          />
        {/if}
      </section>

      <section class="product-image-section">
        <!-- <ProductTileImage data={productStore.productTileImageData} /> -->
        <img
          src="{window.ACC.config.extraThemeResourcePath}/images/spacer_image.gif"
          loading="lazy"
          srcset="{productStore.productTileImageData.amplienceProductBaseUrl}fmt=auto&w=120 120w, 
            {productStore.productTileImageData.amplienceProductBaseUrl}fmt=auto&w=180 180w, 
            {productStore.productTileImageData.amplienceProductBaseUrl}fmt=auto&h=214&w=214 214w,
            {productStore.productTileImageData.amplienceProductBaseUrl}fmt=auto&h=428&w=428 428w"
          sizes="(max-width: 899px) 120px, 214px"
          fetchpriority="auto"
          alt="noname"
          style="object-fit: contain; object-position: center center;"
        />
      </section>
      <section class="product-title-section">
        <ProductTileName data={productStore.productTileTitleData} />
      </section>
      {#if opt?.showRatingReview || data?.isOnlineOnly}
        <section
          class="product-rating-review-section {opt?.showPrice && data?.price && Object.keys(data?.price).length
            ? 'reserved-space'
            : ''}"
        >
          {#if data?.rating}
            <ProductTileRatingReviews data={productStore.productTileRatingData} />
          {/if}
          <OnlineOnlyLabel dividerFlag={data?.rating} showLabel={data?.isOnlineOnly} />
        </section>
      {/if}
      {#if opt?.showPrice && data.price && showPriceForComingSoon}
        <section class="product-price-section">
          <svelte:component
            this={priceComponent}
            isMegasaleProduct={productTags?.length ? checkForMegaSaleProduct(productTags) : []}
            variant="product-tile"
            product={productStore.productTilePriceData}
          />
        </section>

        {#if opt?.showOfferAndGift && (data?.offersLabel || data?.freeGiftCount)}
          <section class="product-offer-section">
            <ProductTileOffer data={productStore.productTileOfferLabelsData} />
          </section>
        {/if}
      {/if}
      {#if data?.comingSoon}
        <div class="coming-soon">
          {getStr('extra.soonmessage')}
        </div>
      {/if}

      <!-- Removing this component because we have QAC button now & also ProductTileActionBtn doesn't have any cta inside it's code -->
      <!-- {#if opt?.showActionBtn}
        <section class="product-action-btn-section">
          <ProductTileActionBtn />
        </section>
      {/if} -->
    </div>
    {#if opt?.showBottomTags && (productStore.productTileBottomTagsData.tagsData.length || productStore.productTileBottomTagsData.isMegasaleProduct.length || (productStore?.productTilePriceData?.isJoodDayFlag && data?.joodDayRemainingQuantity > 0))}
      <section class="bottom-tags-section">
        <ProductBottomTags
          data={productStore.productTileBottomTagsData}
          joodDayData={{
            isJoodDayFlag: productStore?.productTilePriceData?.isJoodDayFlag,
            joodDayRemainingQuantity: data?.joodDayRemainingQuantity,
          }}
        />
      </section>
    {/if}
  </div>
{/if}

<style lang="scss">
  @import '../../styles/colors.new.scss';
  .tile-content-wrapper {
    width: max-content;
    min-height: 100%;
    cursor: pointer;
    .product-tile-container {
      position: relative;
      font-size: 10px;
      line-height: 10px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 12px 12px 16px;
      max-width: var(--mobile-tile-width);
      border: 1px solid $secondary-gray-02;
      border-radius: 12px;
      z-index: 1;
      background-color: $primary-white;
      height: var(--tile-height);
      @include responsive {
        border-radius: 8px;
        font-size: 10px;
        padding: 8px 8px 10px;
      }
      &-bundleMinHeight {
        min-height: 328px;
      }

      @include desktop-min-width {
        max-width: var(--desktop-tile-width);
        padding: 16px 16px 16px;
        gap: 12px;
      }
      .product-image-section {
        margin-top: 12px;

        @include responsive {
          margin-top: 20px;
        }
      }
      .product-title-section {
        min-height: 28px;
        @include desktop-min-width {
          min-height: 32px;
        }
      }
      .product-rating-review-section {
        display: flex;
        align-items: center;
        &.reserved-space {
          min-height: 14px;
          @include desktop-min-width {
            min-height: 16px;
          }
        }
      }
      .coming-soon {
        font-size: 14px;
        line-height: 16px;
        color: $neutral-dark-01;
      }
    }
    .bottom-tags-section {
      // position: absolute;
      // right: 0;
      // left: 0;
      width: var(--mobile-tile-width);
      @include desktop-min-width {
        width: var(--desktop-tile-width);
      }
    }
  }

  :global {
    .tile-content-wrapper {
      .product-tile-container {
        .c_product-price-jood-wallet-container {
          &.c_joodwalletcard {
            .middle {
              padding: 0;
              .c_middle-jood-credits-details {
                padding: 0;
              }
            }
          }
          &.expired {
            .subscribe-upgrade-bottom {
              .c_expirecard {
                .c_infoicon {
                  margin: 0 2px;
                }
                .expired-text-container {
                  padding-top: 2px;
                }
                .expired-text {
                  border: 0;
                  padding-right: 0;
                  &:after {
                    display: none;
                  }
                }
              }
            }
            .credits-details-left {
              .text,
              .price {
                font-size: 12px;
                @include responsive {
                  font-size: 10px;
                }
              }
            }
          }
        }
      }
    }

    .product-list-container {
      .c_product-price-jood-wallet-container {
        &.variant-plp-grid {
          .subscribe-upgrade-bottom {
            .c_expirecard {
              &.price-expire-card {
                font-size: 9px;
              }
              .expired-text-container {
                padding-top: 2px;
                .expired-text {
                  border: 0;
                  padding-right: 0;
                  &:after {
                    display: none;
                  }
                }
              }
              .c_infoicon img {
                width: 8px;
              }
            }
          }

          .credits-details-left {
            .text {
              font-size: 10px;
            }
            img.img {
              width: 7px;
              height: 7px !important;
            }
          }
        }
      }
    }
  }
</style>
